import {RootState} from '../store.types'

export const isSavingAnswers: ((state: RootState) => boolean) = ({savingExamAnswer}) => {
  return savingExamAnswer.length !== 0
}